import { Cookies } from 'react-cookie';
import APIService from '../../services/api';
import { handleError } from '../infos/actions';
import {
    ACCESS_TOKEN_DELETED,
    ACCESS_TOKEN_FAILED,
    ACCESS_TOKEN_DOWNLOADED,
    ACCESS_TOKEN_POSTING,
    ACCESS_TOKEN_PENDING,
    ACCESS_TOKENS_DOWNLOADED,
} from './types';

const cookies = new Cookies();

// Action creators

export const accessTokenPendingAction = () => {
    return {
        type: ACCESS_TOKEN_PENDING,
    };
};

export const postAccessTokenAction = () => {
    return {
        type: ACCESS_TOKEN_POSTING,
    };
};

export const accessTokenDownloadedAction = (accessToken) => {
    return {
        type: ACCESS_TOKEN_DOWNLOADED,
        payload: accessToken,
    };
};

export const accessTokensDownloadedAction = (accessTokens) => {
    return {
        type: ACCESS_TOKENS_DOWNLOADED,
        payload: accessTokens,
    };
};

export const accessTokenDeletedAction = (id) => {
    return {
        type: ACCESS_TOKEN_DELETED,
        payload: id,
    };
};

export const accessTokenFailedAction = (id) => {
    return {
        type: ACCESS_TOKEN_FAILED,
        payload: id,
    };
};

// Actions

export function getAccessTokens(appId) {
    return function (dispatch) {
        dispatch(accessTokenPendingAction());
        return APIService
            .getAccessTokens(appId, cookies.get('token'))
            .then(accessTokens => {
                dispatch(accessTokensDownloadedAction(accessTokens));
            })
            .catch((error) => {
                dispatch(handleError(error, ACCESS_TOKEN_FAILED));
                dispatch(accessTokenFailedAction());
            });
    };
}

export function deleteAccessToken(appId, accessTokenId) {
    return function (dispatch) {
        dispatch(accessTokenDeletedAction());
        return APIService
            .deleteAccessToken(appId, accessTokenId, cookies.get('token'))
            .then(() => {
                dispatch(accessTokenDeletedAction(accessTokenId));
            })
            .catch((error) => {
                dispatch(handleError(error, ACCESS_TOKEN_FAILED));
                dispatch(accessTokenFailedAction());
            });
    };
}

export function postAccessToken(appId, accessTokenName) {
    return function (dispatch) {
        dispatch(postAccessTokenAction());
        return APIService
            .postAccessToken(appId, accessTokenName, cookies.get('token'))
            .then(accessToken => {
                dispatch(accessTokenDownloadedAction(accessToken));
            })
            .catch((error) => {
                dispatch(handleError(error, ACCESS_TOKEN_FAILED));
                dispatch(accessTokenFailedAction());
            });
    };
}



// WEBPACK FOOTER //
// src/store/accessTokens/actions.js